import { ws } from "../../../utils/common";

export const getInfoAssociationWS = async (id) => {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/" + id,
    null,
    null,
    false
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};

export const postViewAndActionPageInvitationWS = async ({
  id_association,
  cta_registration,
  cta_view_association,
}) => {
  const res = await ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "registration-by-invitation",
    null,
    { id_association, cta_registration, cta_view_association },
    false
  );

  if (res.error) {
    throw res;
  } else {
    return res;
  }
};
